import { render, staticRenderFns } from "./ChatMultimediaEmpty.vue?vue&type=template&id=bc8cebde&scoped=true&"
import script from "./ChatMultimediaEmpty.vue?vue&type=script&lang=js&"
export * from "./ChatMultimediaEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ChatMultimediaEmpty.vue?vue&type=style&index=0&id=bc8cebde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8cebde",
  null
  
)

export default component.exports